import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./State/Store/store";
import App from "./App";
import { initializeGame } from "./State/actions";
import useWakeLock from "./Hooks/useWakeLock";
import "./i18n";
// import SessionManager from "./Components/UserInterface/shared/Other/SessionManager";
import HeartbeatManager from "./Components/UserInterface/shared/Other/HeartbeatManager";
import { AppActivityProvider } from "./Contexts/AppActivityContext";
import { ReelControlProvider } from "./Contexts/ReelControlContext";
import { HoldAndWinControlContextProvider } from "./Contexts/HoldAndWinControlContext";
import { FreeSpinControlProvider } from "./Contexts/FreeSpinControlContext";
import { DimensionsProvider } from "./Contexts/DimensionsContext";
import { ReelRefsProvider } from "./Contexts/ReelRefsContext";
import HiddenAutoplayInputs from "./Components/UserInterface/shared/Other/HiddenAutoplayInputs";
import { FEATURES_CONFIG } from "./featuresConfig";

// Dispatch the initialization action
// This will load assets (including fonts) and sounds before showing the game
store.dispatch(initializeGame());

// Wait for DOM to be ready before initializing React
const initApp = () => {
  try {
    // Check if body exists
    if (!document.body) {
      throw new Error("document.body is not available");
    }

    // Try to find existing container
    let container = document.getElementById("game");

    // Create container if it doesn't exist
    if (!container) {
      container = document.createElement("div");
      container.id = "game";
      document.body.appendChild(container);
    }

    // Verify container is in the DOM
    if (!container.parentNode) {
      throw new Error("Failed to attach container to DOM");
    }

    // Create React root
    const root = ReactDOM.createRoot(container);

    const WakeLockBootstrap = React.memo(() => {
      useWakeLock(true);
      return null;
    });

    const FreeSpinControl = FEATURES_CONFIG.FREE_SPINS.ENABLED
      ? FreeSpinControlProvider
      : React.Fragment;
    const HoldAndWinControl = FEATURES_CONFIG.HOLD_AND_WIN.ENABLED
      ? HoldAndWinControlContextProvider
      : React.Fragment;

    // Render the app
    root.render(
      <Provider store={store}>
        <WakeLockBootstrap />
        {/* <SessionManager /> */}

        <HeartbeatManager />
        {FEATURES_CONFIG.RESPONSIBLE_GAMBLING.ENABLED && (
          <HiddenAutoplayInputs />
        )}

        <AppActivityProvider>
          <ReelRefsProvider>
            <FreeSpinControl>
              <HoldAndWinControl>
                <ReelControlProvider>
                  <DimensionsProvider>
                    <App />
                  </DimensionsProvider>
                </ReelControlProvider>
              </HoldAndWinControl>
            </FreeSpinControl>
          </ReelRefsProvider>
        </AppActivityProvider>
      </Provider>,
    );
  } catch (error) {
    throw error;
  }
};

// Ensure DOM is ready before initializing React
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initApp);
} else {
  // DOM is already ready (script loaded after DOMContentLoaded)
  initApp();
}
